import api from '@/api';
import { TRemoveUserRequest } from '@/api/user';
import { addNotificationDanger } from '@/store/slices/notificationsSlice';
import { TUser, TUserUpdate } from '@/types/users';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getUsers = createAsyncThunk<TUser[]>(
    'users/getUsers',
    async (_, thunkAPI) => {
        try {
            return await api.user.getUsers();
        } catch (e) {
            thunkAPI.dispatch(addNotificationDanger({ text: e as string }));
            return [];
        }
    },
);

export const getUserData = createAsyncThunk<TUser | undefined, string>(
    'users/getUserData',
    async (id, thunkApi) => {
        try {
            return await api.user.getUserById(id);
        } catch (e) {
            thunkApi.dispatch(addNotificationDanger({ text: e as string }));
            return undefined;
        }
    },
);

export const removeUser = createAsyncThunk<void, TRemoveUserRequest>(
    'users/removeUser',
    async (data, thunkApi) => {
        try {
            return await api.user.removeUser(data);
        } catch (e) {
            thunkApi.dispatch(addNotificationDanger({ text: e as string }));
            return undefined;
        }
    },
);

export const updateUser = createAsyncThunk<TUser | undefined, TUser>(
    'users/updateUser',
    async (user, thunkApi): Promise<TUser | undefined> => {
        try {
            return await api.user.updateUser(user);
        } catch (e) {
            thunkApi.dispatch(addNotificationDanger({ text: e as string }));
            return undefined;
        }
    },
);

type TCreateUserData = { user: TUserUpdate, callback: () => void }

export const createUser = createAsyncThunk<void, TCreateUserData>(
    'users/updateUser',
    async (data, thunkApi): Promise<void> => {
        try {
            await api.user.createUser(data.user);
            debugger;
            data.callback();
        } catch (e) {
            thunkApi.dispatch(addNotificationDanger({ text: e as string }));
            return undefined;
        }
    },
);

